import { RansackQ } from 'api/clients/AlmanacFilesClient'
import { AlmanacFileIndexItem } from 'hooks/queries/files/types'
import { TreeDataItem, TreeItemType } from './types'

export const VM_ROOT_FOLDERS_QUERY: RansackQ = {
  asset_type_in: ['Project'],
  parent_id_null: true,
  s: 'title asc',
}

export const isVirtualMarketerRootFolder = (file: AlmanacFileIndexItem) => {
  const assetType = file.asset_type?.toLowerCase()
  return assetType === 'project' && !file.parent_id
}

export const toVirtualMarketerTreeItem = (file: AlmanacFileIndexItem, workspaceId: number): TreeDataItem =>
  ({
    id: file.key,
    slug: file.seo_string || undefined,
    title: file.title,
    parent_id: file.parent_id,
    real_workspace_id: workspaceId,
    header_emoji: file.emoji,
    channel_emoji: file.channel_emoji,
    type: TreeItemType.Project,
  } as TreeDataItem)
